export async function api<T>(path:string, options:RequestInit={}) {
  const response=await fetch(`/api${path}`,{credentials:'include',headers:{'content-type':'application/json',...options.headers},...options});
  if(response.status===401) throw Object.assign(new Error('AUTH_REQUIRED'),{status:401});
  const payload=response.status===204?null:await response.json();
  if(!response.ok) throw new Error(payload?.error??`Request failed (${response.status})`);
  return payload as T;
}

export const post=<T>(path:string,body:unknown={})=>api<T>(path,{method:'POST',body:JSON.stringify(body)});

export async function upload<T>(path:string,body:FormData){
  const response=await fetch(`/api${path}`,{method:'POST',body,credentials:'include'});
  if(response.status===401)throw Object.assign(new Error('AUTH_REQUIRED'),{status:401});
  const payload=await response.json().catch(()=>({}));
  if(!response.ok)throw new Error(payload?.error??`Upload failed (${response.status})`);
  return payload as T;
}
